<template>
    <v-container fluid>
        <div v-for="(rule, ruleKey) in section.rules" :key="ruleKey">
            <v-row class="mb-2" align="center">
                <v-col>
                    <strong>Rule {{ ruleKey + 1 }}</strong>
                </v-col>
                <v-col cols="auto">
                    <v-btn class="ies-coral" @click="deleteRule(ruleKey)"><v-icon small>delete</v-icon> Delete</v-btn>
                </v-col>
            </v-row>

            <v-row>
                <!-- Select Model -->
                <v-col cols="12" sm="3">
                    <div class="pb-3">
                        <label>Model</label>
                        <v-autocomplete
                            v-model="rule.modelName"
                            :items="sortModels(models)"
                            placeholder="Select a Model"
                            clearable
                            outlined
                            dense
                            hide-details
                            class="mt-2"
                            @change="rule.fieldName = ''"
                        ></v-autocomplete>
                    </div>
                </v-col>

                <!-- Select Column -->
                <v-col cols="12" sm="3">
                    <div class="pb-3">
                        <label>Column</label>
                        <v-autocomplete
                            v-model="rule.fieldName"
                            :items="sortColumns(rule)"
                            placeholder="Select a Column"
                            clearable
                            outlined
                            dense
                            hide-details
                            class="mt-2"
                        ></v-autocomplete>
                    </div>
                </v-col>

                <!-- Select Operator -->
                <v-col cols="12" sm="2">
                    <div class="pb-3">
                        <label>Operator</label>
                        <v-select
                            v-model="rule.operator"
                            :items="operators"
                            placeholder="Select an Operator"
                            outlined
                            dense
                            hide-details
                            class="mt-2"
                        ></v-select>
                    </div>
                </v-col>

                <!-- Set Value -->
                <v-col cols="12" sm="3">
                    <div class="pb-3">
                        <label>Value</label>
                        <input type="text" v-model="rule.value" class="full-width text-input-border mt-2 pa-2">
                    </div>
                </v-col>
            </v-row>

            <v-divider class="mb-4"></v-divider>
        </div>
    </v-container>
</template>

<script>
    export default {
        name: 'PortalDesignerRules',
        props: ['section', 'sectionkey','models',],
        data () {
            return {
                'currentSection' : this.section,
                'operators': ["!=","==","<",">","&"]
            }
        },
        methods: {
            updateObject: function(){
                this.section = this.currentSection;
            },

            /**
             * Returns an alphabetised array of names of provided models
             * @param models - an object containing models
             */
            sortModels: function(models){
                let keys = Object.keys(models).sort();
                return keys;
            },

            /**
             * Returns an alphabetised array of fields on a given model
             * @param string modelName - the name of a model
             */
            sortColumns: function(rule){
                var fields = this.models[rule.modelName];
                if (fields) {
                    let keys = Object.keys(fields).sort();
                    fields = keys;
                }
                return fields;
            },
            deleteRule: function(ruleKey){
                delete this.section['rules'][ruleKey];
                this.section['rules'] =  this.section['rules'].filter(function(n){ return n != undefined });
                this.currentSection = this.section;
            }
        }
    }
</script>


